import React, { FC } from "react";

export const Grid: FC = ({ children }) => (
  <div className="grid">{children}</div>
);
